import React from "react";

const Java_Scanner_radix = () => {
  return (
    <div>
      <h1>Java Scanner radix</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Scanner radix in Java.</p>
    </div>
  );
};

export default Java_Scanner_radix;
